const legends = {
  // dialTitle: 'dials-icons',
  // pillarTitle: 'pillar-icons',
  tabTitle: 'tab-icons',
  // dials: [
  //   {
  //     color: 'gray',
  //     text: 'currently-not-passing',
  //   },
  //   {
  //     color: 'black',
  //     text: 'no-data-to-display',
  //   },
  //   {
  //     color: 'orange',
  //     text: 'conditional-passing',
  //   },
  //   {
  //     color: 'green',
  //     text: 'currently-passing',
  //   },
  //   {
  //     color: 'red',
  //     text: 'did-not-pass-action-required',
  //   },
  //   {
  //     color: 'blue',
  //     text: 'future-metric',
  //   },
  //   {
  //     color: 'light-gray',
  //     text: 'not-applicable-excluded',
  //   },
  //   {
  //     color: 'yellow',
  //     text: 'approved-appeal',
  //   },
  //   {
  //     color: 'dark-blue',
  //     text: 'ineligible',
  //   },
  //   {
  //     color: 'light-red',
  //     text: 'audit-adjustment',
  //   },
  // ],
  // pillars: [
  //   {
  //     color: 'gray',
  //     text: 'currently-not-passing',
  //   },
  //   {
  //     color: 'green',
  //     text: 'currently-passing',
  //   },
  //   {
  //     color: 'red',
  //     text: 'did-not-pass-action-required',
  //   },
  // ],
  tabs: [
    {
      color: 'gray',
      text: 'not-passing',
    },
    {
      color: 'green',
      text: 'passing',
    },
    {
      color: 'orange',
      text: 'conditional-pass',
    },
    {
      color: 'yellow',
      text: 'approved-appeal',
    },
    {
      color: 'blue',
      text: 'future-metric-pillar',
    },
    {
      color: 'light-gray',
      text: 'not-applicable-excluded',
    },
    {
      color: 'red',
      text: 'failed-action-required',
    },
    {
      color: 'light-red',
      text: 'audit-adjustment',
    },
    {
      color: 'dark-blue',
      text: 'ineligible',
    },
    {
      color: 'black',
      text: 'no-data',
    },
  ],
  columnOne: [
    {
      color: 'gray',
      text: 'not-passing',
    },
    {
      color: 'green',
      text: 'passing',
    },
    {
      color: 'orange',
      text: 'conditional-pass',
    },
    {
      color: 'yellow',
      text: 'approved-appeal',
    },
    {
      color: 'blue',
      text: 'future-metric-pillar',
    },
  ],
  columnTwo: [
    {
      color: 'light-gray',
      text: 'not-applicable-excluded',
    },
    {
      color: 'red',
      text: 'failed-action-required',
    },
    {
      color: 'light-red',
      text: 'audit-adjustment',
    },
    {
      color: 'dark-blue',
      text: 'ineligible',
    },
    {
      color: 'black',
      text: 'no-data',
    },
  ],
};

export default () => legends;
